import { onAppReady } from 'larasnap';

const DELAY = 200; // The amount of time to wait before making the loader visible. This way
// the loader doesn't show if the ajax call is completed quickly

const STEP = 1; // The amount of 'translate3d' percentage that is increased with each
// interval. Generally this should be 1 for the smoothest animation

const INTERVAL = 2; // The length of time between each interval. Total anination
// time will be this multiplied by 100

const COOLDOWN = 500; // The amount of time to wait before restarting
// the progress bar animation

let visible = false;
let showCount = 0;
let element;
let progressBar;

onAppReady(() => {
    element = createElement();
    progressBar = element.find('.ajax-loader-progress-bar');
});

const createElement = () => {
    const html = `
        <div class="ajax-loader">
            <div class="ajax-loader-progress-bar"></div>
            <div class="ajax-loader-spinner"></div>            
        </div>
    `;

    return $(html).appendTo($('body'));
};

const animateProgressBar = () => {
    let progress = 0;

    const intervalId = setInterval(() => {
        progress += STEP;

        progressBar.css('transform', `translate3d(${progress}%, 0px, 0px)`);

        if (progress >= 100) {
            clearInterval(intervalId);

            if (visible) {
                setTimeout(() => {
                    animateProgressBar();
                }, COOLDOWN);
            }
        }
    }, INTERVAL);
};

export const show = () => {
    showCount++;
    visible = true;

    setTimeout(() => {
        if (visible) {
            element.show();
            animateProgressBar();
        }
    }, DELAY);
};

export const hide = () => {
    showCount--;

    if (showCount === 0) {
        visible = false;
        element.hide();
    }
};
